/**
 * Service Worker Registration
 * 注册和管理Service Worker
 */

export async function registerServiceWorker() {
  if (typeof window === 'undefined') {
    return;
  }

  // 只在生产环境启用Service Worker
  if (process.env.NODE_ENV !== 'production') {
    console.log('Service Worker disabled in development');
    return;
  }

  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        '/sw-episode-cache.js',
        {
          scope: '/',
        }
      );

      console.log('Service Worker registered successfully:', registration);

      // 监听Service Worker更新
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              console.log('New Service Worker activated');
              // 可以提示用户刷新页面以获取最新内容
              if (window.confirm('New version available! Refresh to update?')) {
                window.location.reload();
              }
            }
          });
        }
      });

      return registration;
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  }
}

/**
 * 清除特定episode的缓存
 */
export function clearEpisodeCache(episodeId: string) {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'CLEAR_EPISODE_CACHE',
      episodeId: episodeId,
    });
  }
}

/**
 * 预缓存episode数据
 */
export async function precacheEpisode(episodeId: string) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    // 预先获取episode数据，触发缓存
    const response = await fetch(`/api/episodes/${episodeId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
      },
    });

    if (response.ok) {
      console.log(`Episode ${episodeId} precached successfully`);
    }
  } catch (error) {
    console.error(`Failed to precache episode ${episodeId}:`, error);
  }
}

/**
 * 批量预缓存多个episodes
 */
export async function precacheMultipleEpisodes(episodeIds: string[]) {
  const promises = episodeIds.map(id => precacheEpisode(id));
  await Promise.all(promises);
}